<template lang='pug' src='./virtual-orthodontic-consultation.pug'></template>

<script>
import VirtualForm from 'components/form/form-virtual/form-virtual'

export default {
  computed: {
    props () {
      let props = this.$store.state.pages['virtual-orthodontic-consultation']
      let appendedProps = {...props, videoUrl: 'https://starsmilesorthopedo.com/wp-content/uploads/VirtualConsultation-compressed.mov'}
      return appendedProps
      // return this.$store.state.pages['virtual-orthodontic-consultation']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    VirtualForm
  }
}
</script>



// WEBPACK FOOTER //
// virtual-orthodontic-consultation.vue?03e85dce